/**
 * Used for boolean lists that are shown as options
 */
export default [{ value: true, description: 'Sim' }, { value: false, description: 'Não' }];
